var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Toolbar',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('Breadcrumb',{attrs:{"title":_vm.$t('settings')}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }